import React from "react";
import {connect} from "react-redux";
import {Text, TextInput, View, StyleSheet, TouchableOpacity} from "react-native";
import AvatarIcon from "../../Header/AvatarIcon";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {wrapAction, wrapStyle} from "../../../sw/helpers";

class PostCommentInput extends React.Component{
    constructor(props) {
        super(props);
        this.input="";
        this.state ={
            focus :false,
            displayContactContent : false,
            comment : [],
            height:35
        }
    }

    contactContent(text){
        this.setState({
            commentInputValue:text
        });
        this.props.setDisplayContactList(text.includes("@"))
    }

    setFocus(focus){
        this.setState({
            focus : focus
        })
    }



    formattedText(){
        const words = this.props.commentInputValue.split(' ');
        const formattedText = [];
        words.forEach(word => {
            if (!word.startsWith('@')) return formattedText.push(word, ' ');
            const mention = (
                <Text key={word} style={{opacity:1,color:this.props.theme.colors.primary.blue1.value}}>
                    {word}
                </Text>
            );
            formattedText.push(mention, ' ');
        });

        return formattedText;
    }

    render() {
        const styles = StyleSheet.create({
            container:{
                flexDirection:"row",
                justifyContent:"space-between",
                alignItems:"center",
                backgroundColor:this.props.theme.colors.primary.White.value,
                position:"absolute",
                bottom:0,
                paddingHorizontal:12,
                paddingRight:15,
                paddingVertical:10,
                width:"100%",
                borderTopWidth:1,
                borderTopColor : this.props.theme.colors.tertiary.black13.value,
                zIndex:99
            },
            icon:{
                width:35,
                height:35,
                margin:0,
                padding:0,
               // marginBottom:7,
                marginLeft:0,
                marginRight:10,
                borderRadius:14,
                borderWidth:0,
            },
            input:{
                width:210,
                fontSize:16,
                textAlignVertical:"top",
                height:Math.max(35, this.state.height),
                opacity:0.5,
                color:this.props.theme.colors.tertiary.black1.value
            },
            arobase:{
                color : this.props.theme.colors.tertiary.black6.value,
                fontSize:32,
                fontFamily:this.props.theme.fonts.text,
                textAlignVertical:"center",
                justifyContent:"center",
                paddingBottom:7,
            },
            submit: wrapStyle({
                fontSize:15,
                fontWeight:"700",
                justifyContent:"center",
                fontFamily:this.props.theme.fonts.text,
                color : this.state.focus ? this.props.theme.colors.primary.blue1.value : this.props.theme.colors.tertiary.black6.value
            }),
            formatedTextContainer:{
                position:"absolute",
                //backgroundColor:"red",
                height:Math.max(35, this.state.height),
                width:210,
                zIndex: -1
            },
            formatedText:{
                fontSize:16,
                textAlignVertical:"top",
            }
        });
        return (
            <View style={styles.container}>
                <AvatarIcon style={styles.icon} icon={this.props.auth.compte.img} isHeader={true}/>
                <View style={{position:"relative"}}>
                    <View style={styles.formatedTextContainer}>
                        <Text style={styles.formatedText}>{this.formattedText()}</Text>
                    </View>
                    <TextInput
                        ref={(input)=>{this.props.setInputRef(input)}}
                        selectionColor={'red'}
                        multiline={true}
                        value={this.props.commentInputValue}
                        onChange={(text)=>{this.props.setCommentInputValue(text,this.input)}}
                        onEndEditing={()=>this.setFocus(true)} onFocus={()=>this.setFocus(true)}
                        placeholder={this.props.t("Ecrire un commentaire...")}
                        placeholderTextColor={this.props.theme.colors.tertiary.black6.value}
                        style={styles.input}
                        onContentSizeChange={(event) => {
                            this.setState({ height: event.nativeEvent.contentSize.height })
                        }}
                        editable={this.props.online}
                        selectTextOnFocus={this.props.online}
                    />
                </View>
                <TouchableOpacity onPress={wrapAction(()=>{this.props.setDisplayContactList(true)})}><Text style={styles.arobase}>@</Text></TouchableOpacity>
                <TouchableOpacity onPress={wrapAction(this.props.submitCommentaire)}><Text style={styles.submit}>{this.props.t('Publier')}</Text></TouchableOpacity>
            </View>
        );
    }
}


const mapStateToProps = (state) => {
    return {
      isDark: state.changeTheme.isDark, theme: state.changeTheme.theme, auth: state.AuthReducer,
      online: state.sw_reducer.online
    };
}

export default compose(withTranslation(),connect(mapStateToProps))(PostCommentInput);
